import React from 'react';
import { MDText } from 'i18n-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { ENVS, REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import getEnvConfig from './helpers/getEnvConfig';
import { CONFIG_KEYS, DEFAULT_ASSET_STATUS_COLOR } from './consts';
import { AssetShape } from './shapes';
import EntityBlock from '../../EntityBlock';

import './style/_AssetEntityBlock.scss';

/**
 * A component rendering Asset entity block.
 * @param entity
 * @param env
 * @param region
 * @param projectId
 * @param className
 * @param rest
 * @returns {*}
 * @constructor
 */
const AssetEntityBlock = ({ entity, env, region, projectId, className, ...rest }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const deeplinkUrl = `${getEnvConfig(
    env,
    region,
    CONFIG_KEYS.ASSETS_FE
  )}/projects/${projectId}/assets?preview=${entity.id}`;

  return (
    <EntityBlock
      entityTypeName={T.translate('ASSET')}
      title={entity.clientAssetId}
      deeplinkUrl={deeplinkUrl}
      statusText={entity.status ? entity.status.label : T.translate('DEFAULT_ASSET_STATUS_LABEL')}
      statusColor={`status-${entity.status ? entity.status.color : DEFAULT_ASSET_STATUS_COLOR}`}
      className={classNames('AssetEntityBlock', className)}
      isRenderedMultiline
      {...rest}
    />
  );
};

AssetEntityBlock.propTypes = {
  /**
   * The asset entity we need to render
   */
  entity: AssetShape.isRequired,
  /**
   * The environment. One of `ENVS` values.
   */
  env: PropTypes.oneOf(objectValues(ENVS)).isRequired,
  /**
   * The region. One of `REGIONS` values.
   */
  region: PropTypes.oneOf(objectValues(REGIONS)).isRequired,
  /**
   * The project ID
   */
  projectId: PropTypes.string.isRequired,
  /**
   * An optional className to be added to the EntityBlock
   */
  className: PropTypes.string
};

export default AssetEntityBlock;
